import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBlock = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M13.0874 3.73276L3.73276 13.0874C2.85472 11.9582 2.33268 10.5403 2.33268 8.99935C2.33268 5.31745 5.31745 2.33268 8.99935 2.33268C10.5403 2.33268 11.9582 2.85472 13.0874 3.73276ZM4.91127 14.2659L14.2659 4.91127C15.144 6.04051 15.666 7.45843 15.666 8.99935C15.666 12.6813 12.6813 15.666 8.99935 15.666C7.45843 15.666 6.04051 15.144 4.91127 14.2659ZM8.99935 0.666016C4.39697 0.666016 0.666016 4.39697 0.666016 8.99935C0.666016 13.6013 4.39744 17.3327 8.99935 17.3327C13.6017 17.3327 17.3327 13.6017 17.3327 8.99935C17.3327 4.39744 13.6013 0.666016 8.99935 0.666016Z",
		fill: "#D97706"
	})]
});
const ForwardRef = forwardRef(SvgBlock);
export { ForwardRef as ReactComponent };
